import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { PageHead, Section, Spinner, ErrorNote, Empty, useAsync } from '../components/ui';
import { PracticeCardView } from '../components/cards';
import { unenrolledFirst } from '../lib/sort';
import '../styles/learn.css';

/**
 * Practices catalog (design/020). Full published Practice library, one of the
 * two pages the retired /library page split into. Practices are ongoing/
 * repeatable per-Practice-price (design/019).
 */
export default function PracticesBrowsePage() {
  const navigate = useNavigate();
  const { loading, error, data, reload } = useAsync(
    () => api.listLibraryPractices().then((x) => (Array.isArray(x) ? x : [])),
    []
  );

  return (
    <div className="page">
      <PageHead icon="🧘" title="Practices" sub="Browse and join ongoing, repeatable practices" />
      {loading ? <Spinner /> : error ? <ErrorNote error={error} onRetry={reload} /> : (
        <Section>
          {data.length === 0 ? <Empty>No practices published yet.</Empty> : (
            <div className="card-grid">
              {unenrolledFirst(data, 'enrolled').map((p) => (
                <PracticeCardView key={p.id} p={p} onOpen={() => navigate(`/learn/practice/${p.id}`)} />
              ))}
            </div>
          )}
        </Section>
      )}
    </div>
  );
}
